import { Box, Rating, Typography } from '@mui/material'
import React from 'react'
import { colors } from '../styles/colors'
import Image from "../components/Image";
import { ReactComponent as RightChevron } from "../assets/icons/RightChervon.svg";
import dayjs from "dayjs";
import StarIcon from "@mui/icons-material/Star";
import { getLocalStorage } from '../helpers/storage';
import useWindowWidth from '../hooks/useWindowWidth';
import { getCookie } from '../helpers/cookieUtils';
const ReturnToOffer = ({ }) => {
    const [collapsedItems, setCollapsedItems] = React.useState<Record<string, boolean>>({});
    const windowWidth = useWindowWidth();
    let popupData: any[] = [];
    const cookieData = getCookie("sharedCookieData");
    if (cookieData) {
        try {
            const parsed = JSON.parse(decodeURIComponent(cookieData));
            popupData = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
            popupData = [];
        }
    }
    // const popupData = JSON.parse(getLocalStorage("searchCriteria") || "[]");
    const toggleCollapse = (key: string | number) => {
        setCollapsedItems((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    return (
        <Box sx={{ display: "flex", gap: { sm: '20px', xs: '10px' }, justifyContent: "center", flexWrap: "wrap", mb: 2 }}>
            {popupData?.map((item: any, index: number) => {
                const key = item.hotel_id || index;
                const isCollapsed = collapsedItems[key] || false;

                return (
                    <Box
                        sx={{
                            marginX: 2,
                            position: "fixed",
                            bottom: "90px",
                            right: { sm: "20px", xs: "0" }, // Change to `left` for bottom-left
                            bgcolor: "white",
                            color: "black",
                            boxShadow: 12,
                            borderRadius: "8px",
                            p: 2,
                            width: { sm: "500px", },
                            zIndex: 999,
                            minWidth: { sm: "400px" },
                        }}
                    >
                        <Box
                            display="flex"
                            justifyContent={"space-between"}
                            alignItems="center"
                        >
                            <Typography variant="body1" sx={{ fontWeight: '700' }}>Pick up where you left off...</Typography>
                            <Box textAlign="right">
                                <Typography
                                    variant="body1"
                                    onClick={() => toggleCollapse(key)}
                                    sx={{
                                        border: "none",
                                        mt: "0 !important",
                                        ml: "8px",
                                        background: "transparent",
                                        cursor: "pointer",
                                        fontWeight: '500',
                                        color: colors.basics.primary,
                                    }}
                                >
                                    {isCollapsed ? "Show" : "Hide"}
                                </Typography>
                            </Box>
                        </Box>
                        {!isCollapsed && (
                            <a href={item?.url} rel="noreferrer">
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mt={2}
                                    mb={1}
                                >
                                    <Box>
                                        <Image
                                            src={item?.image || "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif"}
                                            alt="logo"
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                borderRadius: "8px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ flexGrow: 1, ml: 2, mr: 2, gap: 2 }}>
                                        <Box
                                            sx={{
                                                "& .MuiRating-root .MuiRating-iconFilled": {
                                                    color: colors.basics.primary,
                                                },
                                                "& .MuiRating-iconHover": {
                                                    color: colors.basics.primary,
                                                },
                                                display: { sm: "flex", xs: "none" },
                                                alignItems: "center",
                                                justifyContent: "flex-start",
                                            }}
                                        >
                                            <Rating
                                                sx={{ fontSize: "21px" }}
                                                value={item?.rating}
                                                precision={0.5}
                                                emptyIcon={
                                                    <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                                                }
                                                readOnly={true}
                                            />
                                        </Box>
                                        <Typography variant="body1" sx={{ fontWeight: '700' }}>
                                            {item.hotel_name}
                                        </Typography>
                                        <Typography>
                                            <span style={{ display: windowWidth > 599 ? 'flex' : "none" }}>   Flying from {item?.searchCriteria?.departure?.depart_airport_name} ({item?.searchCriteria?.departure?.departure_airport}) to </span> {item?.searchCriteria?.destination["Display Name #1"]} ({item?.searchCriteria?.destination?.airport_code})
                                        </Typography>
                                        <Typography>
                                            {dayjs(item?.searchCriteria?.date?.[0], "DD/MM/YYYY").format("MMM DD, YYYY")} • {item?.searchCriteria?.night} nights
                                        </Typography>
                                    </Box>
                                    <Box sx={{
                                        '& svg': {
                                            fill: colors.basics.black,
                                            '& path': {
                                                fill: colors.basics.black,
                                            }
                                        },
                                    }}>
                                        <RightChevron width={20} height={14} />
                                    </Box>
                                </Box>
                            </a>
                        )}
                    </Box>
                )
            })}
        </Box>
    )
}

export default ReturnToOffer